export default __webpack_public_path__ + "static/media/certi.fdf1a590.jpg";